import script from "./CreateEvCar.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateEvCar.vue?vue&type=script&lang=ts&setup=true"

import "./CreateEvCar.vue?vue&type=style&index=0&id=51251102&scoped=true&lang=css"

import exportComponent from "/builds/rentalcar-app/admin-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51251102"]])

export default __exports__